import React, { useState } from "react";
import { useGetAllStatisticsQuery } from "../services/statistics.service";
import { StatsFilter } from "../components/stats-filter";
import { Sections } from "../components/sections";
import PageLoading from "src/components/pageLoading";
import { UserLangCode } from "src/utils/util.types";

export default function Statistics() {
  const [langCode, setLangCode] = useState<UserLangCode>();

  const { data, isSuccess } = useGetAllStatisticsQuery({ langCode });

  const handleFilter = (langCode: UserLangCode) => {
    setLangCode(langCode);
  };

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <StatsFilter onChange={handleFilter} />
        {isSuccess ? <Sections stats={data.stats} expiry={data.expiry} /> : <PageLoading />}
      </div>
    </div>
  );
}

// <StatsActions handleRefresh={() => refetch()} />

// {/* Action Icons */}
// <div className="flex justify-center gap-8 py-8 border-t border-gray-200">
//   <div className="flex flex-col items-center gap-2 cursor-pointer hover:opacity-70 transition-opacity">
//     <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
//       <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth={2}
//           d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//         />
//       </svg>
//     </div>
//     <span className="text-sm text-gray-600">Select</span>
//   </div>
//   <div className="flex flex-col items-center gap-2 cursor-pointer hover:opacity-70 transition-opacity">
//     <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
//       <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16l-4-4m0 0l4-4m-4 4h18" />
//       </svg>
//     </div>
//     <span className="text-sm text-gray-600">Move</span>
//   </div>
//   <div className="flex flex-col items-center gap-2 cursor-pointer hover:opacity-70 transition-opacity">
//     <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
//       <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth={2}
//           d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//         />
//       </svg>
//     </div>
//     <span className="text-sm text-gray-600">Notes</span>
//   </div>
// </div>
